import { CommonModule } from '@angular/common';
import { Component, Input, ViewChild } from '@angular/core';
import { FormBuilder, FormGroup, ReactiveFormsModule, Validators } from '@angular/forms';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatSelectModule } from '@angular/material/select';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { ConfigurationModeEnum } from '~modules/connectors/modules/load/common/services/configuration-mode.service';
import { AccountingEntriesFieldsConfiguration } from '~modules/connectors/services/extract-connectors-configurations/field-type';
import { AccountingEntriesProcessorConfiguration } from '~modules/tools/extract-accounting-entries/entities/accounting-entries-processor-configuration.entity';
import { InvoiceProcessorConfiguration } from '~modules/tools/extract-accounting-entries/entities/invoice-processor-configuration.entity';
import { PaymentProcessorConfiguration } from '~modules/tools/extract-accounting-entries/entities/payment-processor-configuration.entity';
import { AnalyticProcessorConfiguration } from '../../entities/analytic-processor-configuration.entity';
import { AnalyticProcessorConfigurationComponent } from '../analytic-processor-configuration/analytic-processor-configuration.component';
import { InvoiceProcessorConfigurationComponent } from '../invoice-processor-configuration/invoice-processor-configuration.component';
import { PaymentProcessorConfigurationComponent } from '../payment-processor-configuration/payment-processor-configuration.component';
import { ThirdPartPreTransformConfigurationResponse } from '~modules/thirdparts/common/dto/third-part-pre-transform-configuration-configuration-response.dto';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';

export type OptionTypes = 'PAYMENT' | 'SELL-INVOICE' | 'BUY-INVOICE' | 'BANK' |
  'PAYMENT_SELL-INVOICE' | 'PAYMENT_BUY-INVOICE' | 'PAYMENT_BANK' | 'SELL-INVOICE_BUY-INVOICE' | 'SELL-INVOICE_BANK' | 'BUY-INVOICE_BANK' |
  'PAYMENT_SELL-INVOICE_BUY-INVOICE' | 'PAYMENT_SELL-INVOICE_BANK' | 'PAYMENT_BUY-INVOICE_BANK' | 'SELL-INVOICE_BUY-INVOICE_BANK' |
  'PAYMENT_SELL-INVOICE_BUY-INVOICE_BANK';
export type OptionTypesConfiguration = { label: string, hasPaymentConfiguration: boolean, hasSellInvoiceConfiguration: boolean, hasBuyInvoiceConfiguration: boolean, hasBankConfiguration: boolean };
export const configurationOptionDefinitions: Record<OptionTypes, OptionTypesConfiguration> = {
  "PAYMENT": {
    label: 'ENCAISSEMENT',
    hasPaymentConfiguration: true,
    hasSellInvoiceConfiguration: false,
    hasBuyInvoiceConfiguration: false,
    hasBankConfiguration: false
  },
  "SELL-INVOICE": {
    label: 'VENTE',
    hasPaymentConfiguration: false,
    hasSellInvoiceConfiguration: true,
    hasBuyInvoiceConfiguration: false,
    hasBankConfiguration: false
  },
  "BUY-INVOICE": {
    label: 'ACHAT',
    hasPaymentConfiguration: false,
    hasSellInvoiceConfiguration: false,
    hasBuyInvoiceConfiguration: true,
    hasBankConfiguration: false
  },
  "BANK": {
    label: 'BANQUE',
    hasPaymentConfiguration: false,
    hasSellInvoiceConfiguration: false,
    hasBuyInvoiceConfiguration: false,
    hasBankConfiguration: true
  },
  "PAYMENT_SELL-INVOICE": {
    label: 'ENCAISSEMENT + VENTE',
    hasPaymentConfiguration: true,
    hasSellInvoiceConfiguration: true,
    hasBuyInvoiceConfiguration: false,
    hasBankConfiguration: false
  },
  "PAYMENT_BUY-INVOICE": {
    label: 'ENCAISSEMENT + ACHAT',
    hasPaymentConfiguration: true,
    hasSellInvoiceConfiguration: false,
    hasBuyInvoiceConfiguration: true,
    hasBankConfiguration: false
  },
  "PAYMENT_BANK": {
    label: 'ENCAISSEMENT + BANQUE',
    hasPaymentConfiguration: true,
    hasSellInvoiceConfiguration: false,
    hasBuyInvoiceConfiguration: false,
    hasBankConfiguration: true
  },
  "SELL-INVOICE_BUY-INVOICE": {
    label: 'VENTE + ACHAT',
    hasPaymentConfiguration: false,
    hasSellInvoiceConfiguration: true,
    hasBuyInvoiceConfiguration: true,
    hasBankConfiguration: false
  },
  "SELL-INVOICE_BANK": {
    label: 'VENTE + BANQUE',
    hasPaymentConfiguration: false,
    hasSellInvoiceConfiguration: true,
    hasBuyInvoiceConfiguration: false,
    hasBankConfiguration: true
  },
  "BUY-INVOICE_BANK": {
    label: 'ACHAT + BANQUE',
    hasPaymentConfiguration: false,
    hasSellInvoiceConfiguration: false,
    hasBuyInvoiceConfiguration: true,
    hasBankConfiguration: true
  },
  "PAYMENT_SELL-INVOICE_BUY-INVOICE": {
    label: 'ENCAISSEMENT + VENTE + ACHAT',
    hasPaymentConfiguration: true,
    hasSellInvoiceConfiguration: true,
    hasBuyInvoiceConfiguration: true,
    hasBankConfiguration: false
  },
  "PAYMENT_SELL-INVOICE_BANK": {
    label: 'ENCAISSEMENT + VENTE + BANQUE',
    hasPaymentConfiguration: true,
    hasSellInvoiceConfiguration: true,
    hasBuyInvoiceConfiguration: false,
    hasBankConfiguration: true
  },
  "PAYMENT_BUY-INVOICE_BANK": {
    label: 'ENCAISSEMENT + ACHAT + BANQUE',
    hasPaymentConfiguration: true,
    hasSellInvoiceConfiguration: false,
    hasBuyInvoiceConfiguration: true,
    hasBankConfiguration: true
  },
  "SELL-INVOICE_BUY-INVOICE_BANK": {
    label: 'VENTE + ACHAT + BANQUE',
    hasPaymentConfiguration: false,
    hasSellInvoiceConfiguration: true,
    hasBuyInvoiceConfiguration: true,
    hasBankConfiguration: true
  },
  "PAYMENT_SELL-INVOICE_BUY-INVOICE_BANK": {
    label: 'ENCAISSEMENT + VENTE + ACHAT + BANQUE',
    hasPaymentConfiguration: true,
    hasSellInvoiceConfiguration: true,
    hasBuyInvoiceConfiguration: true,
    hasBankConfiguration: true
  }
};

@Component({
  selector: 'app-accounting-entries-processor-configuration',
  standalone: true,
  imports: [
    CommonModule,
    ReactiveFormsModule,
    PaymentProcessorConfigurationComponent,
    InvoiceProcessorConfigurationComponent,
    AnalyticProcessorConfigurationComponent,
    MatProgressSpinnerModule,
    MatFormFieldModule,
    MatIconModule,
    MatSelectModule,
    MatInputModule,
    MatSlideToggleModule
  ],
  templateUrl: './accounting-entries-processor-configuration.component.html',
  styleUrls: ['./accounting-entries-processor-configuration.component.scss']
})
export class AccountingEntriesProcessorConfigurationComponent {

  formGroup!: FormGroup;

  @ViewChild('paymentProcessorConfiguration')
  set paymentConfigurationComponent(value: PaymentProcessorConfigurationComponent) {
    this.formGroup.setControl('paymentProcessorConfiguration', value?.formGroup);
  }
  @ViewChild('sellInvoiceProcessorConfiguration')
  set sellInvoiceConfigurationComponent(value: InvoiceProcessorConfigurationComponent) {
    this.formGroup.setControl('sellInvoiceProcessorConfiguration', value?.formGroup);
  }
  @ViewChild('buyInvoiceProcessorConfiguration')
  set buyInvoiceConfigurationComponent(value: InvoiceProcessorConfigurationComponent) {
    this.formGroup.setControl('buyInvoiceProcessorConfiguration', value?.formGroup);
  }
  @ViewChild('bankProcessorConfiguration')
  set bankConfigurationComponent(value: PaymentProcessorConfigurationComponent) {
    this.formGroup.setControl('bankProcessorConfiguration', value?.formGroup);
  }
  @ViewChild(AnalyticProcessorConfigurationComponent)
  set analyticConfigurationComponent(value: AnalyticProcessorConfigurationComponent) {
    this.formGroup.setControl('analyticProcessorConfiguration', value?.formGroup);
  }
  configurationOptions: OptionTypesConfiguration[] = [];
  fieldsConfig: AccountingEntriesFieldsConfiguration | undefined;
  paymentConfiguration: PaymentProcessorConfiguration | undefined;
  sellInvoiceConfiguration: InvoiceProcessorConfiguration | undefined;
  buyInvoiceConfiguration: InvoiceProcessorConfiguration | undefined;
  bankConfiguration: PaymentProcessorConfiguration | undefined;
  analyticConfiguration: AnalyticProcessorConfiguration | undefined;
  configurationMode: keyof typeof ConfigurationModeEnum | undefined;
  fetchedFieldsConfiguration: ThirdPartPreTransformConfigurationResponse | undefined;
  isLoadingPreConfig = false;

  @Input()
  set existingConfiguration(value: AccountingEntriesProcessorConfiguration | undefined) {
    this.paymentConfiguration = value?.paymentProcessorConfiguration;
    this.sellInvoiceConfiguration = value?.sellInvoiceProcessorConfiguration;
    this.buyInvoiceConfiguration = value?.buyInvoiceProcessorConfiguration;
    this.bankConfiguration = value?.bankProcessorConfiguration;
    this.analyticConfiguration = value?.analyticProcessorConfiguration;
  }

  @Input()
  set configMode(configMode: keyof typeof ConfigurationModeEnum | undefined) {
    this.configurationMode = configMode;
  }

  @Input()
  set fetchedFieldsConfigurationInput(fetchedFieldsConfigurationInput: ThirdPartPreTransformConfigurationResponse | undefined) {
    this.fetchedFieldsConfiguration = fetchedFieldsConfigurationInput;
  }

  @Input()
  set fieldsConfiguration(value: AccountingEntriesFieldsConfiguration | undefined) {
    this.fieldsConfig = value;
    if (value != undefined) {
      this.formGroup.get('option')?.setValue(null);
      this.configurationOptions = [];
      if (value.paymentProcessorConfiguration != null) {
        this.configurationOptions.push(configurationOptionDefinitions['PAYMENT']);
      }
      if (value.sellInvoiceProcessorConfiguration != null) {
        this.configurationOptions.push(configurationOptionDefinitions['SELL-INVOICE']);
      }
      if (value.buyInvoiceProcessorConfiguration != null) {
        this.configurationOptions.push(configurationOptionDefinitions['BUY-INVOICE']);
      }
      if (value.bankProcessorConfiguration != null) {
        this.configurationOptions.push(configurationOptionDefinitions['BANK']);
      }
      if (value.paymentProcessorConfiguration != null && value.sellInvoiceProcessorConfiguration != null) {
        this.configurationOptions.push(configurationOptionDefinitions['PAYMENT_SELL-INVOICE']);
      }
      if (value.paymentProcessorConfiguration != null && value.buyInvoiceProcessorConfiguration != null) {
        this.configurationOptions.push(configurationOptionDefinitions['PAYMENT_BUY-INVOICE']);
      }
      if (value.paymentProcessorConfiguration != null && value.bankProcessorConfiguration != null) {
        this.configurationOptions.push(configurationOptionDefinitions['PAYMENT_BANK']);
      }
      if (value.sellInvoiceProcessorConfiguration != null && value.buyInvoiceProcessorConfiguration != null) {
        this.configurationOptions.push(configurationOptionDefinitions['SELL-INVOICE_BUY-INVOICE']);
      }
      if (value.sellInvoiceProcessorConfiguration != null && value.bankProcessorConfiguration != null) {
        this.configurationOptions.push(configurationOptionDefinitions['SELL-INVOICE_BANK']);
      }
      if (value.buyInvoiceProcessorConfiguration != null && value.bankProcessorConfiguration != null) {
        this.configurationOptions.push(configurationOptionDefinitions['BUY-INVOICE_BANK']);
      }
      if (value.paymentProcessorConfiguration != null && value.sellInvoiceProcessorConfiguration != null && value.buyInvoiceProcessorConfiguration != null) {
        this.configurationOptions.push(configurationOptionDefinitions['PAYMENT_SELL-INVOICE_BUY-INVOICE']);
      }
      if (value.paymentProcessorConfiguration != null && value.sellInvoiceProcessorConfiguration != null && value.bankProcessorConfiguration != null) {
        this.configurationOptions.push(configurationOptionDefinitions['PAYMENT_SELL-INVOICE_BANK']);
      }
      if (value.paymentProcessorConfiguration != null && value.buyInvoiceProcessorConfiguration != null && value.bankProcessorConfiguration != null) {
        this.configurationOptions.push(configurationOptionDefinitions['PAYMENT_BUY-INVOICE_BANK']);
      }
      if (value.sellInvoiceProcessorConfiguration != null && value.buyInvoiceProcessorConfiguration != null && value.bankProcessorConfiguration != null) {
        this.configurationOptions.push(configurationOptionDefinitions['SELL-INVOICE_BUY-INVOICE_BANK']);
      }
      if (value.paymentProcessorConfiguration != null && value.sellInvoiceProcessorConfiguration != null && value.buyInvoiceProcessorConfiguration != null && value.bankProcessorConfiguration != null) {
        this.configurationOptions.push(configurationOptionDefinitions['PAYMENT_SELL-INVOICE_BUY-INVOICE_BANK']);
      }
    }
  }

  @Input()
  set isLoadingPreConfigInput(isLoadingPreConfig: boolean) {
    this.isLoadingPreConfig = isLoadingPreConfig;
  }

  constructor(
    private readonly fb: FormBuilder,
  ) {
    this.formGroup = this.fb.group({
      option: [null, Validators.required],
      paymentProcessorConfiguration: this.paymentConfigurationComponent?.formGroup,
      sellInvoiceProcessorConfiguration: this.sellInvoiceConfigurationComponent?.formGroup,
      buyInvoiceProcessorConfiguration: this.buyInvoiceConfigurationComponent?.formGroup,
      bankProcessorConfiguration: this.bankConfigurationComponent?.formGroup,
      analyticProcessorConfiguration: this.analyticConfigurationComponent?.formGroup,
    });
  }

  compareSelectionObjects(object1: OptionTypesConfiguration, object2: OptionTypesConfiguration) {
    return object1 && object2 && object1.label == object2.label;
  }
}